window.EaseScooterInit = function () {
  'use strict';

  /* Runs once on load and again after every theme-editor section reload.
     Document-level listeners bind once; element setup is guarded per node. */
  var first = !window.__esBound;
  window.__esBound = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduce ? 'auto' : 'smooth';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* =============================================================
     In-page smooth scrolling
     ============================================================= */
  if (first) document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-es-scroll]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: smooth, block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  /* =============================================================
     Gallery: snap track, thumbs, arrows, keyboard, zoom lightbox
     ============================================================= */
  var gallery = $('[data-es-gallery]');
  if (gallery && gallery.getAttribute('data-es-ready') !== '1') {
    gallery.setAttribute('data-es-ready', '1');
    var stage = $('[data-es-stage]', gallery);
    var items = $$('[data-es-item]', gallery);
    var thumbs = $$('[data-es-thumb]', gallery);

    var index = function () {
      return Math.max(0, Math.min(items.length - 1,
        Math.round(stage.scrollLeft / Math.max(1, stage.clientWidth))));
    };
    var goTo = function (i) {
      var n = Math.max(0, Math.min(items.length - 1, i));
      stage.scrollTo({ left: n * stage.clientWidth, behavior: smooth });
    };
    var sync = function () {
      var active = index();
      thumbs.forEach(function (t, i) {
        t.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    };

    var raf = null;
    stage.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; sync(); });
    }, { passive: true });

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    $('[data-es-prev]', gallery).addEventListener('click', function () { goTo(index() - 1); });
    $('[data-es-next]', gallery).addEventListener('click', function () { goTo(index() + 1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      if (!e.target.closest('[data-es-thumb]')) return;
      e.preventDefault();
      var next = thumbs.indexOf(e.target) + (e.key === 'ArrowRight' ? 1 : -1);
      if (next < 0) next = thumbs.length - 1;
      if (next >= thumbs.length) next = 0;
      thumbs[next].focus();
      goTo(next);
    });

    window.addEventListener('resize', sync);
    sync();

    /* zoom lightbox */
    var zoomBtn = $('[data-es-zoom]', gallery);
    if (zoomBtn && typeof HTMLDialogElement !== 'undefined') {
      zoomBtn.addEventListener('click', function () {
        var dlg = document.getElementById('ease-scooter-page-lightbox');
        if (!dlg) {
          dlg = document.createElement('dialog');
          dlg.id = 'ease-scooter-page-lightbox';
          document.body.appendChild(dlg);
          dlg.addEventListener('click', function (ev) {
            if (ev.target.closest('.es-lb__close') || ev.target.classList.contains('es-lb__slide')) {
              dlg.close();
              return;
            }
            var prev = ev.target.closest('.es-lb__nav--prev');
            var next = ev.target.closest('.es-lb__nav--next');
            if (!prev && !next) return;
            var tr = dlg.querySelector('.es-lb__track');
            var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)) + (next ? 1 : -1);
            tr.scrollTo({ left: i * tr.clientWidth, behavior: smooth });
          });
        }

        var html = '' +
          '<button type="button" class="es-lb__close" aria-label="Close">&times;</button>' +
          '<button type="button" class="es-lb__nav es-lb__nav--prev" aria-label="Previous">' +
            '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 1L3 6l5 5"/></svg></button>' +
          '<button type="button" class="es-lb__nav es-lb__nav--next" aria-label="Next">' +
            '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 1l5 5-5 5"/></svg></button>' +
          '<div class="es-lb__track">';

        items.forEach(function (item) {
          var full = item.getAttribute('data-es-full');
          var img = item.querySelector('img');
          if (full) {
            html += '<div class="es-lb__slide"><img src="' + full + '" alt=""></div>';
          } else if (img) {
            html += '<div class="es-lb__slide"><img src="' + img.getAttribute('src') + '" alt=""></div>';
          } else {
            html += '<div class="es-lb__slide">' + item.innerHTML + '</div>';
          }
        });

        html += '</div><div class="es-lb__count"><span data-es-lb-cur>1</span> / ' + items.length + '</div>';
        dlg.innerHTML = html;

        var track = dlg.querySelector('.es-lb__track');
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          var cur = dlg.querySelector('[data-es-lb-cur]');
          if (cur) cur.textContent = String(i + 1);
        }, { passive: true });

        var start = index();
        dlg.showModal();
        requestAnimationFrame(function () {
          track.scrollTo({ left: start * track.clientWidth, behavior: 'auto' });
        });
      });
    }
  }

  /* =============================================================
     Setup selector — repoints the real form and mirrors the price
     ============================================================= */
  function textOf(node) { return node ? node.textContent.trim() : ''; }

  function selectSetup(card) {
    var setup = card.closest('[data-es-setup]');
    if (!setup) return;

    $$('[data-es-card]', setup).forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      var radio = c.querySelector('input[type="radio"]');
      if (radio) radio.checked = on;
    });

    var form = card.closest('form');
    if (form) {
      var idInput = form.querySelector('[data-es-variant-id]');
      var qtyInput = form.querySelector('[data-es-qty]');
      if (idInput && card.getAttribute('data-variant-id')) {
        idInput.value = card.getAttribute('data-variant-id');
      }
      if (qtyInput) qtyInput.value = card.getAttribute('data-quantity') || '1';
    }

    var price = textOf(card.querySelector('.es-opt__price'));
    var compare = textOf(card.querySelector('.es-opt__compare'));
    if (price) {
      $$('[data-es-price-current]').forEach(function (el) { el.textContent = price; });
      $$('[data-es-price-compare]').forEach(function (el) {
        el.textContent = compare;
        el.hidden = !compare;
      });
    }
  }

  if (first) document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-es-card]');
    if (card) selectSetup(card);
  });

  var preselected = $('[data-es-card].is-selected');
  if (preselected) selectSetup(preselected);

  /* =============================================================
     Clip row — auto-advance every N seconds.
     Pauses while the pointer is over the row, while a card has focus,
     and for as long as one of the clips is actually playing.
     ============================================================= */
  $$('[data-es-ugc]').forEach(function (track) {
    if (track.getAttribute('data-es-ready') === '1') return;
    track.setAttribute('data-es-ready', '1');
    var cards = $$('[data-es-ugc-card]', track);
    if (cards.length < 2) return;

    var every = parseInt(track.getAttribute('data-es-interval'), 10) || 3000;
    var timer = null, idx = 0, held = false;

    function mark() {
      cards.forEach(function (c, i) { c.classList.toggle('is-current', i === idx); });
    }
    function centre(i) {
      var card = cards[i];
      if (!card) return;
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth - card.clientWidth) / 2,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }
    function step() {
      if (held) return;
      idx = (idx + 1) % cards.length;
      mark();
      centre(idx);
    }
    function start() {
      if (timer || reduce) return;
      timer = setInterval(step, every);
      track.setAttribute('data-es-auto', 'on');
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    track.addEventListener('mouseenter', stop);
    track.addEventListener('mouseleave', function () { if (!held) start(); });
    track.addEventListener('focusin', stop);
    track.addEventListener('focusout', function () { if (!held) start(); });
    track.addEventListener('touchstart', stop, { passive: true });

    /* a playing clip holds the reel until it ends or is paused */
    track.addEventListener('play', function () { held = true; stop(); }, true);
    track.addEventListener('pause', function () { held = false; start(); }, true);
    track.addEventListener('ended', function () { held = false; start(); }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!held) { start(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !held) { start(); } else { stop(); }
        });
      }, { threshold: 0.3 }).observe(track);
    } else {
      start();
    }

    mark();
  });

  /* =============================================================
     Inline video playback (clip row)
     ============================================================= */
  if (first) document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-es-video-open]');
    if (!btn) return;
    var media = btn.parentElement;
    var src = media && media.getAttribute('data-es-video-src');
    if (!src) return;

    $$('.es-ugc__media.is-playing').forEach(function (m) {
      m.classList.remove('is-playing');
      var v = m.querySelector('video');
      if (v) v.remove();
      var p = m.querySelector('.es-play');
      if (p) p.hidden = false;
    });

    var video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    media.appendChild(video);
    media.classList.add('is-playing');
    btn.hidden = true;
  });

  /* Hide play buttons with no video source yet. */
  $$('[data-es-video-open]').forEach(function (btn) {
    var media = btn.parentElement;
    if (!media || !media.getAttribute('data-es-video-src')) btn.hidden = true;
  });

  /* =============================================================
     HAPT video — show the player only once a source is set
     ============================================================= */
  var vidBox = $('[data-es-video]');
  if (vidBox && vidBox.getAttribute('data-es-ready') !== '1') {
    vidBox.setAttribute('data-es-ready', '1');
    var vidEl = vidBox.querySelector('video');
    var vidSrc = vidBox.querySelector('source');
    if (vidEl && vidSrc && vidSrc.getAttribute('src')) {
      vidEl.hidden = false;
      var vidEmpty = vidBox.querySelector('[data-es-video-empty]');
      if (vidEmpty) vidEmpty.remove();
      var vidNeed = vidBox.querySelector('.es-vid__need');
      if (vidNeed) vidNeed.remove();
    }
  }

  /* =============================================================
     Persona tabs
     ============================================================= */
  var personas = $('[data-es-personas]');
  if (personas && personas.getAttribute('data-es-ready') !== '1') {
    personas.setAttribute('data-es-ready', '1');
    var pTabs = $$('[data-es-persona-tab]', personas);
    var pPanels = $$('.es-personas__panel', personas);

    var activate = function (tab) {
      var i = pTabs.indexOf(tab);
      if (i < 0) return;
      pTabs.forEach(function (t, n) {
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        if (n === i) t.removeAttribute('tabindex');
        else t.setAttribute('tabindex', '-1');
      });
      pPanels.forEach(function (p, n) {
        p.classList.toggle('is-active', n === i);
        if (n === i) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    };

    personas.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-es-persona-tab]');
      if (tab) activate(tab);
    });

    personas.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-es-persona-tab]');
      if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      var n = pTabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
      if (n < 0) n = pTabs.length - 1;
      if (n >= pTabs.length) n = 0;
      pTabs[n].focus();
      activate(pTabs[n]);
    });
  }

  /* =============================================================
     Comparison table — mobile swipe progress
     ============================================================= */
  var cmpScroller = $('[data-es-cmp-scroller]');
  var cmpThumb = $('[data-es-cmp-thumb]');
  if (cmpScroller && cmpThumb && cmpScroller.getAttribute('data-es-ready') !== '1') {
    cmpScroller.setAttribute('data-es-ready', '1');
    cmpScroller.addEventListener('scroll', function () {
      var max = cmpScroller.scrollWidth - cmpScroller.clientWidth;
      var p = max > 0 ? cmpScroller.scrollLeft / max : 0;
      var trackW = cmpThumb.parentElement.clientWidth;
      cmpThumb.style.transform = 'translateX(' + (p * (trackW - cmpThumb.clientWidth)) + 'px)';
    }, { passive: true });
  }

  /* =============================================================
     FAQ accordion — one open at a time
     ============================================================= */
  var faq = $('[data-es-faq]');
  if (faq && faq.getAttribute('data-es-ready') !== '1') {
    faq.setAttribute('data-es-ready', '1');
    faq.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-es-faq-btn]');
      if (!btn) return;
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      $$('[data-es-faq-btn]', faq).forEach(function (other) {
        if (other === btn) return;
        other.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(other.getAttribute('aria-controls'));
        if (p) p.setAttribute('data-open', 'false');
      });

      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (panel) panel.setAttribute('data-open', isOpen ? 'false' : 'true');
    });
  }

  /* =============================================================
     Jump to the buy box (final CTA + sticky bar)
     ============================================================= */
  function focusAtc() {
    var form = document.getElementById('ease-scooter-atc-form');
    if (!form) return;
    form.scrollIntoView({ behavior: smooth, block: 'center' });
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.focus({ preventScroll: true });
  }
  if (first) document.addEventListener('click', function (e) {
    if (e.target.closest('[data-es-jump-atc]') || e.target.closest('[data-es-sticky-atc]')) focusAtc();
  });

  /* =============================================================
     Sticky bar — visible once the buy box has scrolled past
     ============================================================= */
  var sticky = $('[data-es-sticky]');
  var buyRow = $('.es-box__atc');
  if (sticky && buyRow && sticky.getAttribute('data-es-ready') !== '1') {
    sticky.setAttribute('data-es-ready', '1');
    var ticking = false;
    var update = function () {
      ticking = false;
      var on = buyRow.getBoundingClientRect().bottom < 0;
      sticky.setAttribute('data-visible', on ? 'true' : 'false');
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('pageshow', onScroll);
    update();
  }


  /* =============================================================
     Variant picker — only rendered when the product has real options.
     Keeps the form's hidden id and the displayed price in sync.
     ============================================================= */
  $$('[data-es-variant-select]').forEach(function (sel) {
    if (sel.getAttribute('data-es-ready') === '1') return;
    sel.setAttribute('data-es-ready', '1');
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var form = sel.closest('form');
      if (form) {
        var idInput = form.querySelector('[data-es-variant-id]');
        if (idInput) idInput.value = sel.value;
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          var sold = opt.getAttribute('data-available') === 'false';
          btn.disabled = sold;
          btn.textContent = sold ? (btn.getAttribute('data-soldout') || 'Sold out')
                                 : (btn.getAttribute('data-label') || btn.textContent);
        }
      }
      var price = opt.getAttribute('data-price');
      if (price) {
        $$('[data-es-price-current]').forEach(function (el) { el.textContent = price; });
        $$('.es-opt__price').forEach(function (el) { el.textContent = price; });
      }
    });
  });

  /* =============================================================
     Scroll reveal
     ============================================================= */
  var revealables = $$('.es-reveal:not(.is-in)');
  if (!revealables.length) return;

  if (reduce || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var obs = new IntersectionObserver(function (entries, o) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      o.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  revealables.forEach(function (el) { obs.observe(el); });
};
window.EaseScooterInit();

/* Theme editor: re-run initialisation when a section is added or reloaded. */
document.addEventListener('shopify:section:load', function () {
  var root = document.getElementById('ease-scooter-page') || document.querySelector('.es-root');
  if (root) root.removeAttribute('data-es-init');
  if (window.EaseScooterInit) window.EaseScooterInit();
});
